<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">FFC Hub</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Create
          Content
        </span>
      </base-button>
    </div>
    <HubTable />
  </b-card>
</template>

<script>
import HubTable from "./components/hubTable.vue";
export default {
  components: {
    HubTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "add-ffc-hub" });
    },
  },
};
</script>
<style></style>
